import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {
  Button,
  ButtonGroup,
  Divider,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Slider,
} from "@mui/material";
import React, { ChangeEvent, useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { Context } from "../../../Context/context";
import { baseStyle } from "../../../theme";
import { ColorTheme } from "../../../TypesAndConstants/const";
import { BrushModes, ShapeSetting } from "../../../TypesAndConstants/types";
import { PenPreview } from "../BottomMenu/Pen/PenPreview";
import ShapeContainer from "../BottomMenu/Shapes/ShapeContainer";


interface Props {
  activeBrush: BrushModes;
  useMobileFontSize?: boolean;
}

export const BrushSettingFactory = (props: Props) => {
  const { activeBrush } = props;
  const {
    state: {
      brushCount,
      brushSpeed,
      growShrink,
      penPath,
      penRadius,
      penSpeed,
      shapeSettings,
      wipeCount,
      wipeSpeed,
      wipeSpan,
      wipeDirection,
    },
    dispatch,
  } = React.useContext(Context);

  const [currentPath, setCurrentPenPath] = useState<number>(0);
  const styles = baseStyle({});

  useEffect(() => {
    if (currentPath !== penPath) {
      setCurrentPenPath(penPath);
    }
  }, [penPath]);

  const setBrushCount = (
    event: Event,
    value: number | number[],
    activeThumb: number
  ) => {
    dispatch({ type: "set_brush_count", value: value });
  };

  const setBrushSpeed = (
    event: Event,
    value: number | number[],
    activeThumb: number
  ) => {
    dispatch({ type: "set_brush_speed", value: value });
  };

  const setPath = (
    event: Event,
    value: number | number[],
    activeThumb: number
  ) => {
    dispatch({ type: "set_pen_path", value: value });
  };

  const setRadius = (
    event: Event,
    value: number | number[],
    activeThumb: number
  ) => {
    dispatch({ type: "set_pen_radius", value: value });
  };

  const setPenSpeed = (
    event: Event,
    value: number | number[],
    activeThumb: number
  ) => {
    dispatch({ type: "set_pen_speed", value: value });
  };

  const setWipeCount = (
    event: Event,
    value: number | number[],
    activeThumb: number
  ) => {
    dispatch({ type: "set_wipe_count", value: value });
  };

  const setWiggle = (
    event: Event,
    value: number | number[],
    activeThumb: number
  ) => {
    dispatch({ type: "set_wipe_speed", value: value });
  };

  const setSpan = (
    event: Event,
    value: number | number[],
    activeThumb: number
  ) => {
    dispatch({ type: "set_wipe_span", value: value });
  };

  const setShapeSize = (
    event: Event,
    value: number | number[],
    activeThumb: number
  ) => {
    const shape: ShapeSetting = {
      shape: shapeSettings.shape,
      imageIndex: shapeSettings.imageIndex,
      shapeSize: value as number,
      shapeRotation: shapeSettings.shapeRotation,
    };
    dispatch({ type: "set_shape", value: shape });
  };

  const setShapeRotationMode = (
    event: ChangeEvent<HTMLInputElement>,
    value: string
  ) => {
    const shape: ShapeSetting = {
      shape: shapeSettings.shape,
      shapeSize: shapeSettings.shapeSize,
      imageIndex: shapeSettings.imageIndex,
      shapeRotation: value as any,
    };
    dispatch({ type: "set_shape", value: shape });
  };

  const setGrowShrink = (event: any) => {
    dispatch({ type: "set_grow_shrink", value: event.target.value });
  };

  const responsiveStyle = styles.sliderContainer;

  const SpringMenu = () => {
    return (
      <>
        <div className={responsiveStyle}>
          {" "}
          <label>Count</label>
          <Slider
            defaultValue={3}
            aria-labelledby="discrete-slider-small-steps"
            onChange={setBrushCount}
            step={1}
            marks
            min={1}
            max={5}
            value={brushCount}
            valueLabelDisplay="auto"
          />
        </div>
        <div className={responsiveStyle}>
          {" "}
          <label>Speed</label>
          <Slider
            defaultValue={20}
            aria-labelledby="discrete-slider-small-steps"
            onChange={setBrushSpeed}
            min={1}
            max={40}
            value={brushSpeed}
            valueLabelDisplay="auto"
          />
        </div>
      </>
    );
  };
  const PenMenu = () => {
    return (
      <div>
        <div className={responsiveStyle}>
          {" "}
          <label>Path</label>
          <Slider
            defaultValue={0}
            onChange={setPath}
            step={1}
            marks
            min={0}
            max={22}
            value={penPath}
            valueLabelDisplay="auto"
          />
        </div>
        <div style={{ display: penPath !== 0 ? "block" : "none" }}>
          <div className={responsiveStyle}>
            {" "}
            <label>Radius</label>
            <Slider
              onChange={setRadius}
              min={1}
              max={400}
              value={penRadius}
              valueLabelDisplay="auto"
            />
          </div>
          <div className={responsiveStyle}>
            {" "}
            <label>Speed</label>
            <Slider
              aria-labelledby="discrete-slider-small-steps"
              onChange={setPenSpeed}
              min={1}
              max={100}
              value={penSpeed}
              valueLabelDisplay="auto"
            />
          </div>
        </div>
      </div>
    );
  };
  const WipeMenu = () => {
    return (
      <div>
        <div style={{ display: "flex", textAlign: "center", margin: "10px" }}>
          {isMobile ? (
            <div style={{ width: "100%", margin: "0 auto" }}>
              <ButtonGroup
                color="primary"
                variant="contained"
                aria-label="outlined primary button group"
              >
                <Button
                  onClick={() => {
                    dispatch({ type: "set_wipe_dir", value: "left" });
                  }}
                  focusRipple={wipeDirection === "left"}
                >
                  {" "}
                  <ArrowBackIosIcon />
                </Button>
                <Button
                  onClick={() => {
                    dispatch({ type: "set_wipe_dir", value: "up" });
                  }}
                  focusRipple={wipeDirection === "up"}
                >
                  {" "}
                  <ArrowBackIosIcon
                    style={{ transform: "rotate(90deg)", display: "block" }}
                  />
                </Button>
                <Button
                  onClick={() => {
                    dispatch({ type: "set_wipe_dir", value: "right" });
                  }}
                  focusRipple={wipeDirection === "right"}
                >
                  {" "}
                  <ArrowBackIosIcon
                    style={{
                      transform: "rotate(180deg)",
                    }}
                  />
                </Button>
                <Button
                  onClick={() => {
                    dispatch({ type: "set_wipe_dir", value: "bottom" });
                  }}
                  focusRipple={wipeDirection === "bottom"}
                >
                  {" "}
                  <ArrowBackIosIcon
                    style={{
                      transform: "rotate(270deg)",
                    }}
                  />
                </Button>
              </ButtonGroup>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                height: "75px",
                width: "85px",
                margin: "0 auto",
                alignItems: "center",
              }}
            >
              <div className={"leftButton"} style={{ marginTop: "13px" }}>
                <ArrowBackIosIcon
                  onClick={() => {
                    dispatch({ type: "set_wipe_dir", value: "left" });
                  }}
                />
              </div>
              <div
                className={"upDown"}
                style={{ display: "grid", height: "40px" }}
              >
                <ArrowBackIosIcon
                  style={{
                    transform: "rotate(90deg)",
                  }}
                  onClick={() => {
                    dispatch({ type: "set_wipe_dir", value: "up" });
                  }}
                />
                <ArrowBackIosIcon
                  style={{
                    transform: "rotate(270deg)",
                  }}
                  onClick={() => {
                    dispatch({ type: "set_wipe_dir", value: "bottom" });
                  }}
                />
              </div>
              <div className={"rightButton"} style={{ marginTop: "13px" }}>
                <ArrowBackIosIcon
                  style={{
                    transform: "rotate(180deg)",
                  }}
                  onClick={() => {
                    dispatch({ type: "set_wipe_dir", value: "right" });
                  }}
                />
              </div>
            </div>
          )}
        </div>
        <div className={responsiveStyle}>
          <label>Count</label>
          <Slider
            defaultValue={8}
            onChange={setWipeCount}
            step={1}
            marks
            min={1}
            max={14}
            value={wipeCount}
            valueLabelDisplay="auto"
          />
        </div>
        <div className={responsiveStyle}>
          {" "}
          <label>Span:</label>
          <Slider
            defaultValue={1}
            onChange={setSpan}
            min={10}
            max={1000}
            value={wipeSpan}
            valueLabelDisplay="auto"
          />
        </div>
        <div className={responsiveStyle}>
          {" "}
          <label>Bend:</label>
          <Slider
            defaultValue={1}
            onChange={setWiggle}
            min={0}
            max={100}
            value={wipeSpeed}
            valueLabelDisplay="auto"
          />
        </div>
      </div>
    );
  };

  const GrowShrinkMenu = () => {
    return (
      <div>
        <div className={responsiveStyle}>
          {" "}
          <label id="continuous-slider">Speed</label>
          <Slider
            defaultValue={20}
            aria-labelledby="discrete-slider-small-steps"
            onChange={setBrushSpeed}
            min={1}
            max={40}
            value={brushSpeed}
            valueLabelDisplay="auto"
          />
        </div>
        <FormControl>
          <RadioGroup
            aria-labelledby="growShrink-group-label"
            defaultValue="grow"
            row
            value={growShrink}
            onChange={setGrowShrink}
            name="grow-shrink-radio-buttons-group"
          >
            <FormControlLabel value="grow" control={<Radio />} label="Grow" />
            <FormControlLabel
              value="shrink"
              control={<Radio />}
              label="Shrink"
            />
          </RadioGroup>
        </FormControl>
      </div>
    );
  };

  const ShapeMenu = () => {
    return <ShapeContainer />;
  };

  const menuBottomOffset =
    activeBrush === "pen" || activeBrush === "wipe"
      ? "15vh"
      : activeBrush === "shape"
      ? "20vh"
      : "32vh";

  return (
    <div
      style={{
        border: `2px solid ${ColorTheme.primaryText}`,
        borderRadius: "5px",
        boxShadow: "4px 4px 8px",
        padding: "10px",
        backgroundColor: "#0000000a",
        bottom: isMobile ? 0 : menuBottomOffset,
        fontSize: props.useMobileFontSize ? "auto" : "30px",
        textTransform: "uppercase",
        width: isMobile ? "auto" : "12em",
      }}
    >
      <div
        style={{
          width: "100%",
          textAlign: "center",
          fontSize: "2rem",
          fontFamily: "carter, cursive",
        }}
      >{`${props.activeBrush} Settings`}</div>

      <div
        style={{
          display: activeBrush === "pen" ? "block" : "none",
        }}
      >
        {PenPreview(currentPath)}
        {PenMenu()}
      </div>

      <div style={{ display: activeBrush === "growshrink" ? "block" : "none" }}>
        {GrowShrinkMenu()}
      </div>
      <div
        style={{
          display: activeBrush === "shape" && !isMobile ? "block" : "none",
        }}
      >
        {ShapeMenu()}
      </div>
      <div style={{ display: activeBrush === "wipe" ? "block" : "none" }}>
        {WipeMenu()}
      </div>
      <div style={{ display: activeBrush === "spring" ? "block" : "none" }}>
        {SpringMenu()}
      </div>
    </div>
  );
};

export default React.memo(BrushSettingFactory);
